import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { BaseDialog } from 'components'
import useStyles from './styles'

const ApprovalCollectDialog = ({ open, setOpen, onSubmit }) => {
  const classes = useStyles()

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Nova aprovação necessária"
      closeButtonText="Cancelar"
      actionButtonText="Confirmar"
      actionButton={onSubmit}
      justifyActions="flex-end"
      dialogSize="md"
    >
      <Box mb={3}>
        <Typography variant="body1" paragraph>
          Para garantir a rastreabilidade e a validade das informações, será
          necessário coletar uma nova aprovação antes da publicação da versão
          atualizada.
        </Typography>

        <Typography variant="body1">
          A solicitação de aprovação
          <strong>
            {' '}
            será enviada automaticamente aos mesmos destinatários{' '}
          </strong>
          que aprovaram a versão anterior.
        </Typography>
      </Box>

      <Box className={classes.cardInfo} mb={2}>
        <Typography variant="body1">
          Você pode <strong>editar a lista de aprovadores</strong>, dentro da
          aba <strong>APROVAÇÃO</strong>, caso seja necessário incluir ou
          remover usuários.
        </Typography>
      </Box>

      <Box className={classes.cardInfo} mb={2}>
        <Typography variant="body1">
          Caso a{' '}
          <strong>coleta de aceites (assinaturas) esteja vinculada,</strong> a
          solicitação de nova assinatura também será enviada automaticamente aos
          mesmos destinatários que assinaram a versão anterior, após a aprovação
          do documento
        </Typography>
      </Box>
    </BaseDialog>
  )
}

ApprovalCollectDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ApprovalCollectDialog
